import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import DetailedStatistics from '../../components/Stats/DetailedStatistics';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['textMessage']}`;

const TextMessagesStatisticsPage = () => {
  const fetch = useFetch();

  const [textMessage, setTextMessage] = useState();
  const [error, setError] = useState();
  const { accountId, domainId, textMessageId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/textMessages/${textMessageId}`)
      .then(({ textMessage }) => setTextMessage(textMessage))
      .catch(setError);
  }, [accountId, domainId, textMessageId, fetch]);

  return (
    <>
      <Metadata title={`${page} | ${textMessage?.name || 'Unnamed text message'}`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/textMessages`}>{page}</Anchor>
        <Text>{textMessage?.name || 'Unnamed text message'}</Text>
      </Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          {error ? (
            <ErrorMessage message={error.message} />
          ) : (
            <DetailedStatistics name={textMessage?.name} scope="textMessages" id={textMessageId} />
          )}
        </Grid.Col>
      </Grid>
    </>
  );
};

export default TextMessagesStatisticsPage;
